import { render, staticRenderFns } from "./ResumeClaimPath.vue?vue&type=template&id=46ddfb22&scoped=true"
import script from "./ResumeClaimPath.vue?vue&type=script&lang=js"
export * from "./ResumeClaimPath.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/resume-claim.css?vue&type=style&index=0&id=46ddfb22&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ddfb22",
  null
  
)

export default component.exports